import { api } from ".";

// Define the response type for analytics data
interface IAnalyticsResponse {
  data: {
    iframeUrl: string;
  };
}

// Create analytics query endpoints
const analyticsQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getAnalyticsUrl: builder.query<IAnalyticsResponse, { accountId?: string }>({
      query: ({ accountId }) =>
        accountId
          ? `accounts/analytics?accountId=${accountId}`
          : "accounts/analytics",
    }),
  }),
});

export const { useGetAnalyticsUrlQuery } = analyticsQueries;
